import { formatCalendarDate } from '@lib/datetime'
import { countLabel } from '@/utils/plural'
import React from 'react'
import styled from 'styled-components'
import { fontSizes } from '@/theme/typography'
import { black, textMuted } from '@/theme/colors'
import { Pill } from '@components/Pill'

interface TripHeaderProps {
	tripName: string
	dayCount: number
	startDate: string
	endDate: string
}

const Container = styled.div`
	display: flex;
	justify-content: center;
	padding: 48px 16px 24px 16px;
	flex-shrink: 0;
	margin-bottom: 80px;
`

const HeaderStack = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;
`

const TripName = styled.span`
	font-size: ${fontSizes.hero};
	font-weight: 700;
	color: ${black};
`

const SubRow = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	color: ${textMuted};
	font-size: ${fontSizes.base};
	font-weight: 500;
`

const DaysBadge = styled(Pill).attrs({ $tone: 'outline' as const, $size: 'lg' as const })``

const TripHeader: React.FC<TripHeaderProps> = ({ tripName, dayCount, startDate, endDate }) => {
	const formatDate = (date: string): string => {
		return formatCalendarDate(date, 'medium') || 'Not set'
	}

	return (
		<Container>
			<HeaderStack>
				<TripName>{tripName}</TripName>
				<SubRow>
					<DaysBadge>
						{countLabel(dayCount, 'Day')}
					</DaysBadge>
					<span>
						{formatDate(startDate)} to {formatDate(endDate)}
					</span>
				</SubRow>
			</HeaderStack>
		</Container>
	)
}

export default TripHeader
